import React, { FC, ReactNode } from 'react';
import { MobileDeviceFrame, MobileDeviceNotch, MobileStatusBar, MessagingBackground } from './MobilePreview.styles';

export interface MobilePreviewProps {
  /** Content rendered inside the messaging area (e.g. RichCard message bubble). */
  children?: ReactNode;
  /** Optional status bar text (e.g. "0:00"). When non-empty, the status bar is shown. */
  statusBarText?: string;
  /** Whether to show the device notch. Defaults to true. */
  showNotch?: boolean;
  width?: string;
  /** Max-width for the frame (default 375px). */
  maxWidth?: string;
  'data-testid'?: string;
}

export const MobilePreview: FC<MobilePreviewProps> = ({
  children,
  statusBarText = '0:00',
  showNotch = true,
  width,
  maxWidth,
  'data-testid': dataTestId,
}) => {
  return (
    <MobileDeviceFrame $width={width} $maxWidth={maxWidth} data-testid={dataTestId ?? 'MobilePreview'}>
      {showNotch && <MobileDeviceNotch />}
      {statusBarText != null && statusBarText !== '' && (
        <MobileStatusBar data-testid="MobilePreviewStatusBar">{statusBarText}</MobileStatusBar>
      )}
      <MessagingBackground data-testid="MobilePreviewMessagingBackground">{children}</MessagingBackground>
    </MobileDeviceFrame>
  );
};
